import React, { FC } from "react";
import { AlertTitleProps } from "@material-ui/lab/AlertTitle";
import { StyledMuiAlertTitle } from './styles';

const AlertTitle: FC<AlertTitleProps> = (props) => {
  return (
    <StyledMuiAlertTitle {...props} />
  );
};

export default AlertTitle;
